import React from 'react';

import { useIntl } from 'react-intl';

import { useOrderHref } from 'hooks/use-order-href';
import { routes } from 'utils/routing';

import ChangeServiceModeLinkContents from './change-service-mode-link-contents';
import { ChangeServiceModeLinkProps } from './types';

export const getRouteForLink = (isOrderingEnabled: boolean, nonCateringRoute: string) => {
  if (!isOrderingEnabled) {
    return routes.storeLocator;
  }
  return nonCateringRoute;
};

const ChangeServiceModeLink: React.FC<ChangeServiceModeLinkProps> = ({
  storeSelected = true,
  orderingEnabled = true,
}) => {
  const { formatMessage } = useIntl();
  const nonCateringRoute = useOrderHref({ forceStoreChange: true });

  const noValidStoreSelected = !storeSelected && !orderingEnabled;

  const linkText = noValidStoreSelected
    ? formatMessage({ id: 'selectRestaurant' })
    : formatMessage({ id: 'change' });
  const linkLabel = noValidStoreSelected ? linkText : formatMessage({ id: 'changeAddress' });

  const linkRoute = getRouteForLink(orderingEnabled, nonCateringRoute);

  return (
    <ChangeServiceModeLinkContents
      linkLabel={linkLabel}
      linkRoute={linkRoute}
      linkText={linkText}
      orderingEnabled={orderingEnabled}
    />
  );
};

export default ChangeServiceModeLink;
